import {Repository} from '@/repositories/Base/Repository'

class AuditRepository extends Repository {
    endpoint = 'audit/logs'

    listAll(params) {
        return this.$axios.get(`${this.endpoint}`, {params})
    }

    listAllByModelId(modelId, params) {
        return this.$axios.get(`${this.endpoint}/detail/${modelId}`, {params})
    }

    getLastByModelId(modelId) {
        return this.$axios.get(`${this.endpoint}/detail/last/${modelId}`)
    }
}

export default new AuditRepository()